import React from 'react';
import {
	CSSTransition,
	TransitionGroup,
} from 'react-transition-group';

export const Fader = ({children}) => (
	<TransitionGroup>{
		React.Children.map(children, (item, idx) => 
			item ? (
				<CSSTransition
					key={idx}
					classNames="fader"
					timeout={300}
				>
					{item}
				</CSSTransition>
			) : null
		)
	}</TransitionGroup>
);